module.exports = __webpack_public_path__ + "static/media/SteamGensbanner.cf2ef926.jpg";